import { Helmet } from 'react-helmet-async';

const About = () => {
  return (
    <>
      <Helmet>
        <title>About ChooseMyCollege — Free TNEA College Predictor Tamil Nadu</title>
        <meta name="description" content="ChooseMyCollege is a free TNEA college predictor and cutoff comparison tool for Tamil Nadu engineering admissions. Helping students make informed decisions since 2024." />
        <meta property="og:title" content="About ChooseMyCollege — Free TNEA College Predictor Tamil Nadu" />
        <meta property="og:url" content="https://choosemycollege.in/about" />
        <link rel="canonical" href="https://choosemycollege.in/about" />
      </Helmet>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8">About ChooseMyCollege</h1>
        
        <div className="space-y-6">
          <div className="card">
            <h2 className="text-2xl font-bold mb-4 text-gray-800">Our Mission</h2>
            <p className="text-gray-600">
              To help students and parents make informed decisions about engineering college admissions in Tamil Nadu
              by providing comprehensive data analysis, cutoff comparisons, and personalized predictions.
            </p>
          </div>

          <div className="card">
            <h2 className="text-2xl font-bold mb-4 text-gray-800">What We Offer</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Comprehensive database of 500+ engineering colleges</li>
              <li>Historical cutoff data from 2020 to 2025</li>
              <li>Advanced college predictor based on rank and preferences</li>
              <li>Interactive cutoff comparison tools</li>
              <li>Trending department analysis</li>
              <li>Detailed college information including facilities, fees, and location</li>
            </ul>
          </div>

          <div className="card">
            <h2 className="text-2xl font-bold mb-4 text-gray-800">Who's Behind ChooseMyCollege</h2>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-blue-600 text-white font-extrabold text-xl flex items-center justify-center flex-shrink-0">S</div>
              <div>
                <p className="font-semibold text-gray-800">Selva — TNEA Counselling Advisor</p>
                <p className="text-gray-600 text-sm mt-1">
                  Selva guides students and parents through Tamil Nadu engineering admissions every counselling
                  season and writes the guides on our blog. The platform's data tools are built around TNEA cutoff
                  records covering 470+ colleges across all 38 districts.
                </p>
              </div>
            </div>
          </div>

          <div className="card">
            <h2 className="text-2xl font-bold mb-4 text-gray-800">Data Sources</h2>
            <p className="text-gray-600">
              All data is compiled from official TNEA counselling records, college websites, and verified sources.
              We continuously update our database to ensure accuracy.
            </p>
          </div>

          <div className="card">
            <h2 className="text-2xl font-bold mb-4 text-gray-800">Contact Us</h2>
            <p className="text-gray-600">
              For questions, feedback, or data corrections, please reach out to us at:
            </p>
            <p className="text-primary-600 font-medium mt-2">
              info@choosemycollege.in
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;

